export default __webpack_public_path__ + "9a6805b4c1dea3bb9f2fedc541fb7fea.png";